module.exports = "<svg width=\"12\" height=\"20\" viewBox=\"0 0 12 20\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n<path d=\"M11.307 1.605L9.89 0.194001L4.31694e-07 10.124L9.892 20L11.305 18.585L2.826 10.121L11.307 1.605Z\" fill=\"#262626\"/>\n</svg>\n"


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/slider-left-arrow.svg
// module id = 455
// module chunks = 0